// components.
import { FieldsCO } from './FieldsCO/FieldsCO';
import { ApproveFormBase } from '../shared/ApproveFormBase';
import { defaultValuesCO } from '../utils';
import { calculateYears } from '@domains/hermes/utils/calculateYears';
import { ApproveFormCO as ApproveFormCOType } from '@domains/documents-review/interfaces/interfaces';

export const ApproveFormCO = () => {
  const formatTaskResult = (data: any): ApproveFormCOType => {
    return {
      comment: data.comment,
      property_type: data.propertyType,
      elevators: data.elevators ? Number(data.elevators) : undefined,
      has_admin: Boolean(data.hasAdmin),
      admin_price: Number(data.adminPrice ?? 0),
      construction_date: data.constructionDate,
      area_type: data.areaType,
      area: Number(data.area),
      baths: Number(data.baths),
      floor: Number(data.floor),
      has_garage: data.hasGarage,
      garage: Number(data.garage ?? 0),
      has_terrace: Boolean(data.hasTerrace),
      free_area: Number(data.freeArea),
      liens: data.liens,
      lien_category: data.liensCategory,
      lender_bank: data.lenderBank,
      years_old: calculateYears(data.constructionDate) ?? 0,
    };
  };

  return (
    <ApproveFormBase
      fieldsComponent={<FieldsCO />}
      defaultValues={defaultValuesCO}
      formatTaskResult={formatTaskResult}
      className="pb-4"
    />
  );
};
